import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { FencingRecord, IFencingData } from "common/records/Fencing";

export const FETCH_FENCING_BY_MEASUREMENT_ID = "@measurements_fencings/FETCH_FENCING_BY_MEASUREMENT_ID";
export const CREATE_FENCING_BY_MEASUREMENT_ID = "@measurements_fencings/CREATE_FENCING_BY_MEASUREMENT_ID";
export const RECEIVE_FENCING = "@measurements_fencings/RECEIVE_FENCING";
export const RECEIVE_FENCING_ERRORS = "@measurements_fencings/RECEIVE_FENCING_ERRORS";
export const SET_FENCING = "@measurements_fencings/SET_FENCING";
export const DELETE_FENCING = "@measurements_fencings/DELETE_FENCING";
export const UPDATE_TOTALS = "@measurements_fencing/UPDATE_TOTALS";
export const RESET_FENCING = "@measurements_fencing/RESET_FENCING";

export const FencingActions = {
  updateTotals: (fencingId: number) => createAction(UPDATE_TOTALS, { fencingId }),
  setFencing: (fencing: FencingRecord) => createAction(SET_FENCING, { fencing }),
  resetFencing: (fencingId: number) => createAction(RESET_FENCING, { fencingId }),
  deleteFencing: (fencingId: number, cascade = true) => createAction(DELETE_FENCING, { fencingId, cascade }),
  fetchFencingByMeasurementId: (measurementId: number) =>
    createAction(FETCH_FENCING_BY_MEASUREMENT_ID, { measurementId }),
  receiveFencing: (fencing: Partial<IFencingData>) => createAction(RECEIVE_FENCING, { fencing }),
  receiveFencingErrors: (measurementId: number, errors: string[]) =>
    createAction(RECEIVE_FENCING_ERRORS, { measurementId, errors }),
  createFencingForMeasurementId: (measurementId: number) =>
    createAction(CREATE_FENCING_BY_MEASUREMENT_ID, { measurementId }),
};

export type FencingActions = ActionsUnion<typeof FencingActions>;
